<div class="pageheader">
  <div class="page-title">
    @if (isFallback) {
      <h1>New Fallback Distribution</h1>
    }
    @else {
    <h1>New Distribution</h1>
  }
</div>
</div>
<div class="container container-fixed">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label>Document Type</label>
        <select class="form-control" [ngModel]="selectedDistributionObject" (ngModelChange)="selectedDistributionObject = $event" id="distributionOptions">
          <option [ngValue]="null">Please choose...</option>
          @for (distributionObject of distributionObjects; track distributionObject) {
            <option [ngValue]="distributionObject">{{distributionObject.Name}}</option>
          }
        </select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button class="btn btn-primary" type="button" [disabled]="!selectedDistributionObject" (click)="save()">Ok</button>
      <button class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>